import { trans } from '@lingoda/i18n';
import {
    chromeLinkRenderer,
    edgeLinkRenderer,
    firefoxLinkRenderer,
    safariLinkRenderer,
} from './linkValueRenderers';
import type { LinkValueRenderer } from './linkValueRenderers';
import type { WellSupportedBrowser } from '../../../utils';

interface TranslationProps {
    message: string;
    values: Record<string, LinkValueRenderer>;
}

type TranslationKeyPrefix =
    | 'your-browser-is-not-up-to-date-generic-banner'
    | 'your-browser-is-not-up-to-date-to-join-class-banner';

const chromiumValues = {
    link1: chromeLinkRenderer,
    link2: edgeLinkRenderer,
};

const safariValues = {
    link1: safariLinkRenderer,
};

const firefoxValues = {
    link1: firefoxLinkRenderer,
};

const getGenericBannerTranslationProps = (browserName: WellSupportedBrowser): TranslationProps => {
    switch (browserName) {
        case 'chrome':
        case 'edge':
            return {
                message: trans(
                    'your-browser-is-not-up-to-date-generic-banner.body-chromium',
                    {},
                    'classroom-common+intl-icu',
                ),
                values: chromiumValues,
            };
        case 'safari':
            return {
                message: trans(
                    'your-browser-is-not-up-to-date-generic-banner.body-safari',
                    {},
                    'classroom-common+intl-icu',
                ),
                values: safariValues,
            };
        case 'firefox':
            return {
                message: trans(
                    'your-browser-is-not-up-to-date-generic-banner.body-firefox',
                    {},
                    'classroom-common+intl-icu',
                ),
                values: firefoxValues,
            };
    }
};

const getJoinClassBannerTranslationProps = (
    browserName: WellSupportedBrowser,
): TranslationProps => {
    switch (browserName) {
        case 'chrome':
        case 'edge':
            return {
                message: trans(
                    'your-browser-is-not-up-to-date-to-join-class-banner.body-chromium',
                    {},
                    'classroom-common+intl-icu',
                ),
                values: chromiumValues,
            };
        case 'safari':
            return {
                message: trans(
                    'your-browser-is-not-up-to-date-to-join-class-banner.body-safari',
                    {},
                    'classroom-common+intl-icu',
                ),
                values: safariValues,
            };
        case 'firefox':
            return {
                message: trans(
                    'your-browser-is-not-up-to-date-to-join-class-banner.body-firefox',
                    {},
                    'classroom-common+intl-icu',
                ),
                values: firefoxValues,
            };
    }
};

export const getBrowserTranslationProps = (
    browserName: WellSupportedBrowser,
    keyPrefix: TranslationKeyPrefix,
): TranslationProps => {
    switch (keyPrefix) {
        case 'your-browser-is-not-up-to-date-generic-banner':
            return getGenericBannerTranslationProps(browserName);
        case 'your-browser-is-not-up-to-date-to-join-class-banner':
            return getJoinClassBannerTranslationProps(browserName);
    }
};
